import { memo } from 'react';

import { AutoComplete, Button, ConfigProvider, Flex, Typography } from 'antd';

import { useCitySearch } from '../hooks/useCitySearch';

const { Text } = Typography;

function CitySelector({ className, defaultValue, disabled = false, handleClear, handleSelect }) {
  const { loading, error, hasMore, options, totalCount, onSearch, loadMore } = useCitySearch();

  const enhancedOptions = [
    {
      label: <Text type="secondary">Total results: {totalCount}</Text>,
      value: '__info_row__',
      disabled: true
    },
    ...options,
    ...(hasMore
      ? [
          {
            label: (
              <Button
                type="link"
                block
                onClick={e => {
                  e.stopPropagation();
                  loadMore();
                }}>
                Load more
              </Button>
            ),
            value: '__load_more__'
          }
        ]
      : [])
  ];

  return (
    <ConfigProvider theme={{ token: { colorTextPlaceholder: 'rgba(0,0,0,0.88)' } }}>
      <Flex className={className} align="center" justify="space-between" gap="small">
        <AutoComplete
          className="w-100"
          allowClear={true}
          disabled={disabled}
          loading={loading}
          options={enhancedOptions}
          placeholder={defaultValue ?? 'Search city...'}
          onClear={handleClear}
          onSearch={onSearch}
          onSelect={handleSelect}
        />

        {error && <Text type="danger">{error}</Text>}
      </Flex>
    </ConfigProvider>
  );
}

export default memo(CitySelector);
